import type { FunctionComponent, ReactNode } from 'react'
import React from 'react'

import styles from './PISearchContent.module.scss'

export const PISearchContent: FunctionComponent<Props> = ({ children }) => {
  return (
    <section className={styles.searchContainer} data-testid="ea-search-content">
      {children}
    </section>
  )
}

type Props = {
  children?: ReactNode
}
